function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["basket_data", "delivery_amount", "order_id", "points_config", "price_increase"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var clone = require('clone');
var _export = require('./export.js');
var transformPurchase = require('./transform.js');
var usePromoService = require('../purchase/promotions.js');
var _require = require('../purchase'),
  configPurchaseService = _require.configPurchaseService;
var purchaseService = null;
var _generateDeliveryAsProduct = function _generateDeliveryAsProduct(deliveryAmount, orderId) {
  return {
    byweight: false,
    dept: 'Delivery  Fees ',
    effectiveQuantity: 1,
    intCcPrice: deliveryAmount,
    intPrice: deliveryAmount,
    ismodifier: false,
    name: 'Delivery Fee',
    priceTaxFeeAdjustments: [],
    pricing: {
      cents: deliveryAmount,
      fee_multiplier: 1,
      inclfees: false,
      incltaxes: false,
      qty: 1
    },
    qty: 1,
    refund: false,
    revauths: [],
    showtext: "Delivery Fee (Order #".concat(orderId, ")"),
    skuprice: deliveryAmount,
    skuqty: 1,
    taxinc: false,
    upc: null
  };
};

// Calculates the promo disc and returning totals & items array with new price/discounts
var calculateCart = function calculateCart(_ref) {
  var basket_data = _ref.basket_data,
    delivery_amount = _ref.delivery_amount,
    order_id = _ref.order_id,
    points_config = _ref.points_config,
    price_increase = _ref.price_increase,
    rest = _objectWithoutProperties(_ref, _excluded);
  purchaseService = configPurchaseService(_objectSpread({
    points_config: points_config,
    price_increase: price_increase
  }, rest));
  var items = {};
  if (price_increase.enabled) {
    var purchases = clone(purchaseService.purchases);
    for (var i = 0, p; p = purchases[i]; i++) {
      for (var j = 0, ptf; ptf = (_p$priceTaxFeeAdjustm = p.priceTaxFeeAdjustments) === null || _p$priceTaxFeeAdjustm === void 0 ? void 0 : _p$priceTaxFeeAdjustm[j]; j++) {
        var _p$priceTaxFeeAdjustm;
        if (ptf.name === 'feebuster') {
          purchases[i] = ptf.extra.cashPrice;
          break;
        }
      }
    }
    var cashItems = {};
    purchases.forEach(function (p) {
      cashItems[p.uuid] = transformPurchase(purchaseService, p, price_increase.excludedDepts);
    });
    purchaseService.purchases.forEach(function (p) {
      items[p.uuid] = transformPurchase(purchaseService, p, price_increase.excludedDepts, cashItems[p.uuid]);
    });
  } else {
    purchaseService.purchases.forEach(function (p) {
      items[p.uuid] = transformPurchase(purchaseService, p, price_increase.excludedDepts);
    });
  }
  if (delivery_amount) {
    var deliveryitem = _generateDeliveryAsProduct(delivery_amount, order_id);
    items.deliveryitem = deliveryitem;
  }
  var promoService = usePromoService(purchaseService);
  var savingsMap = promoService.getBuyMoreAndSaveList();
  items = promoService.addBuyMoreAndSave(items, savingsMap);
  return _export(items, purchaseService, {
    basket_data: basket_data,
    delivery_amount: delivery_amount,
    points_config_enabled: points_config === null || points_config === void 0 ? void 0 : points_config.enabled
  });
}; // calculateCart

module.exports = calculateCart;